<template>
    <component :is="hasInvalidRecords ? 'vx-dropdown' : 'div'" justify="center" align="top">
        <span
            class="w-full text-right"
            :class="{ 'text-danger': hasInvalidRecords }"
            v-html="recordCount"
        />
        <sup>
            <vx-basic-icon
                v-if="hasInvalidRecords"
                color="danger"
                size="3"
                class="ml-1"
                icon="InfoIcon"
            />
        </sup>
        <template slot="menu">
            <div
                class="csv-error-list flex flex-col p-4 text-nowrap"
                style="min-width: 400px; height: 400px"
            >
                <vx-scroll-area>
                    <div v-for="(file, fileIndex) in files" :key="`file_${fileIndex}`">
                        <h5 class="pb-1 sticky top-0 bg-light">{{ file.file.name }}</h5>
                        <div
                            v-for="(error, errorIndex) in file.errors"
                            :key="`file_${fileIndex}_${errorIndex}`"
                            class="w-full mb-4 inline-flex flex-nowrap"
                        >
                            <strong style="min-width: 2rem"> {{ error.rowNumber }}: </strong>
                            <span class="text-danger"> {{ error.message }} </span>
                        </div>
                        <vs-divider class="mt-0" />
                    </div>
                </vx-scroll-area>
            </div>
        </template>
    </component>
</template>

<script>
export default {
    name: 'csv-error-list',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        files: {
            type: Array,
            default: () => []
            // example: [
            //     {
            //         records: [],
            //         totalRecords: 45,
            //         errors: {
            //             rowNumber: 4,
            //             message: 'Missing required column: "description"'
            //         }
            //     }
            // ]
        }
    },
    data() {
        return {}
    },
    watch: {},
    computed: {
        shouldShow() {
            return this.show && this.hasInvalidRecords
        },
        totalValidRecords() {
            return this.files.sum((f) => f.records.length)
        },
        totalRecords() {
            return this.files.sum((f) => f.totalRecords)
        },
        recordCount() {
            var valid = this.totalValidRecords
            if (!this.shouldShow) {
                return `<strong>${valid}</strong> Total Records`
            }
            return `<strong>${this.totalValidRecords}/${this.totalRecords}</strong> Valid Records`
        },
        hasInvalidRecords() {
            return this.totalValidRecords < this.totalRecords
        }
    },
    methods: {},
    mounted() {},
    created() {}
}
</script>

<style lang="scss" scoped></style>
